import { getImageExtensionFromType, ImageMime } from '../../utils/imageTypes';
import { getImageFilenameAndExtension } from './getImageFilenameAndExtension';

interface ImageURLProps {
  imagePath: string;
  width: number;
  height: number;
  type: ImageMime;
  filters: string;
  imagesDomain: string;
}
export function getMediaPlatformImageUrl({
  type,
  imagePath,
  imagesDomain,
  width,
  height,
  filters,
}: ImageURLProps): string {
  const extension = getImageExtensionFromType(type);
  const { filename } = getImageFilenameAndExtension(imagePath);
  const allFilters = encodeURIComponent(`w_${width},h_${height},${filters}`);
  // TODO: THIS IS A BIG HACK
  // There is an automated tool that uploaded images to invalid place
  // and this join breaks, as there is no such images on the imagesMediaPlatformDomain
  // details here https://wix.slack.com/archives/CHPLYDSLE/p1793266751618689
  if (imagePath.startsWith('/media')) {
    imagesDomain = 'static.wixstatic.com';
  }

  return `//${imagesDomain}${imagePath}/v1/fill/${allFilters}/${filename}.${extension}`;
}
